import request from '@/utils/request'

/**
 * 查询资讯列表
 * @param data
 */
export const getColumnList = (data) => {
  return request({
    url: '/sol/wap/column',
    method: 'get',
    params: data
  })
}

/**
 * 查询资讯详情
 * @param data
 */
export const getColumnDetail = (id) => {
  return request({
    url: `/sol/wap/column/${id}`,
    method: 'get'
  })
}

/**
 * 查询相关栏目
 * @param data
 */
export const getColumnRelevance = (data, id) => {
  return request({
    url: `/sol/wap/column/${id}/relevance`,
    method: 'get',
    params: data
  })
}

/**
 * 查询栏目标签列表
 * @param data
 */
export const getColumnLabel = () => {
  return request({
    url: `/sol/wap/column_tag`,
    method: 'get'
  })
}

/**
 * 查询我的下载记录
 * @param data
 */
export const getPaymentList = (data) => {
  return request({
    url: '/sol/wap/payment/download',
    method: 'get',
    params: data
  })
}
/**
 * 查询我的收藏记录
 * @param data
 */
export const getCollectList = (data) => {
  return request({
    url: '/sol/wap/solutions/getCollectList',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/news/news.js